import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Header, StyledContentBlock, StyledSection } from './styled';
import BuySellTrade from '../BuySellTrade';
import Security from '../Security';
import ERC from '../ERC';
import Manage from '../Manage';
import Markets from '../Markets';
import Collective from '../Collective';
import MoveMoney from '../MoveMoney/MoveMoney';

const Features = ({ locale }) => {
  const { messages } = useIntl();
  return (
    <>
      <StyledSection>
        <StyledContentBlock>
          <Header locale={locale}>
            {messages['home.buy-sell-trade.header']}
          </Header>
        </StyledContentBlock>
      </StyledSection>
      <BuySellTrade />
      <Security />
      <ERC />
      <Collective />
      <Manage />
      <Markets />
      <MoveMoney />
    </>
  );
};
Features.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Features;
